export default __webpack_public_path__ + "static/media/pebsal_linde.4457aa76.png";